import { useAppSelector } from 'hooks/reduxHooks'
import { getMembershipYearContext, type MembershipYearContext } from 'loyalty/lib/membershipYearUtils'
import { useMemo } from 'react'

/**
 * Returns the boundaries of the member's current membership year + the retain-variant
 * classification used by the hero/drawer cards.
 */
function useCurrentMembershipYear(): MembershipYearContext | undefined {
  const account = useAppSelector(state => state.loyalty.account.data)

  return useMemo(
    () => getMembershipYearContext(account?.statusReviewDate, account?.membershipYearEndDate, account?.createdAt),
    [account?.statusReviewDate, account?.membershipYearEndDate, account?.createdAt],
  )
}

export default useCurrentMembershipYear
